import { useState, useEffect, useContext } from "react";
import "./common.scss";
import FormRendererContext from "../../services/context/FormRendererContext";
import { currentFormattedDateAndTime, trackEvent } from "../../utils/mixPanel";
import { isUrl } from "../../utils/generalUtils";

const NumberInput = ({ data, setAnswer, formValidation, formClass }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [validForm, setFormValidation] = useState(formValidation);
  const { answerData, isJourneyReadOnly } = useContext(FormRendererContext);

  const handleFocus = (e) => {
    trackEvent(`num-field ${data?.label} clicked`, {
      question: data?.label,
      questionKey: data?.key,
      clickedAt: currentFormattedDateAndTime(),
    });
  };
  const handleBlur = (e) => {
    trackEvent(`num-field ${data?.label} filled`, {
      question: data?.label,
      questionKey: data?.key,
      clickedAt: currentFormattedDateAndTime(),
      // filledValue: selectedOption,
      data: "Answered",
    });
  };

  useEffect(() => {
    setFormValidation(formValidation);
    if (data?.answer) {
      setSelectedOption(data.answer?.value);
      setFormValidation(true);
    } else setSelectedOption("");

    if (answerData?.[data?.key]) {
      setSelectedOption(answerData?.[data?.key]?.value);
    }
  }, [formValidation, data]);

  return (
    <div className={`w-full ${formClass}`}>
      <div className="form-title pt-3">
        {data.label}

        {data?.validate?.required ? (
          <span className={!validForm ? "text-red-700" : ""}> * </span>
        ) : (
          <></>
        )}
      </div>
      <form className="flex-grow">
        <div className="radio-common">
          <input
            type="number"
            disabled={data?.disabled || isJourneyReadOnly || false}
            min={data?.validate?.min}
            max={data?.validate?.max}
            value={selectedOption}
            onChange={(e) => {
              setSelectedOption(e.target.value);
              setAnswer(data, { value: e.target.value });
              setFormValidation(true);
            }}
            onFocus={(e) => {
              handleFocus(e);
            }}
            onBlur={(e) => {
              handleBlur(e);
            }}
            className="text-field text-input"
          />
          {data?.validate?.required && !validForm ? (
            <span className="text-red-700 font-light text-xs">
              {" "}
              Required Field{" "}
            </span>
          ) : (
            <></>
          )}
        </div>
      </form>
      {data?.description && (
        <div className="text-xs text-gray-500 leading-relaxed mt-1">
          {isUrl(data.description) ? (
            <img
              src={data.description}
              alt="Description"
              className="mt-1 rounded"
              style={{ maxHeight: "200px" }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.style.display = "none";
                e.target.parentNode.textContent = data.description;
              }}
            />
          ) : (
            data.description
          )}
        </div>
      )}
    </div>
  );
};
export default NumberInput;
